<template>
  <div style="font-family: cerebriSansBold;">
    <div
      style="font-size: .625rem; color: #95aac9!important; text-transform: uppercase; letter-spacing: .08em;"
    >{{ smallTitle }}</div>
    <div style="font-size: 1.625rem;">
      {{ title }}
      <b-button
        variant="primary"
        v-if="buttonName"
        @click="buttonClick"
        style="float: right; font-family: cerebriSansReg; font-size: .9375rem;"
      >{{ buttonName }}</b-button>
    </div>
    <hr />
  </div>
</template>
<script>
export default {
  name: "Header",
  props: {
    title: String,
    smallTitle: String,
    buttonName: String
  },
  methods: {
    buttonClick() {
      this.$emit("buttonClick");
    }
  }
};
</script>